import LoadingScreen from '@sophocles/components/LoadingScreen/LoadingScreen';

export default LoadingScreen;
